






















































































































import { Component, Vue } from 'vue-property-decorator';
import LayoutTitle from '@/components/LayoutTitle.vue';
import LayoutContent from '@/components/LayoutContent.vue';
import FormInput from '@/components/FormInput.vue';
import Toggle from '@/components/Toggle.vue';
import Table from '@/components/Table/Table.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import SubHeader from '@/components/Table/SubHeader.vue';
import Cell from '@/components/Table/Cell.vue';
import Checkbox from '@/components/Checkbox.vue';
import Loader from '@/components/Loader.vue';
import Button from '@/components/Button.vue';
import SearchRow from '@/components/SearchRow.vue';
import SearchField from '@/components/SearchField.vue';
import Select from '@/components/Select.vue';

// import { showToast } from '@/libs/toast';
// import { ToastType } from '@/store/toast';
import api from '@/libs/api';
// import { AxiosError } from 'axios';

@Component({
  components: {
    LayoutTitle,
    LayoutContent,
    FormInput,
    Toggle,
    Table,
    Row,
    Header,
    SubHeader,
    Cell,
    Checkbox,
    Loader,
    Button,
    SearchRow,
    SearchField,
    Select,
  },
})
export default class BulkInvoiceDetail extends Vue {
  loading = false;
  dataBulkInvoice: any[] = [];

  mounted() {
    this.getBulkInvoive();
  }

  back() {
    this.$router.push('/easyinvoice/etransaction/listbulkinvoice');
  }

  async getBulkInvoive() {
    try {
      this.loading = true;
      const idTransactionNumber = `${this.$route.params.id}`;
      const { data } = await api.post('/easyinvoice/invoices_list_bulk', {
        /* eslint-disable @typescript-eslint/camelcase */
        user_group: '5',
        user_id: '1',
        transaction_number: idTransactionNumber,
      });
      // this.getCustommer();
      // const inEmail = data.data.data[0].
      this.dataBulkInvoice = data.data.data;
      this.loading = false;
    } catch (err) {
      this.loading = false;
    }
  }
}
